import { render, staticRenderFns } from "./ActiveHoursRoute.vue?vue&type=template&id=58243843&scoped=true&"
import script from "./ActiveHoursRoute.vue?vue&type=script&lang=js&"
export * from "./ActiveHoursRoute.vue?vue&type=script&lang=js&"
import style0 from "./ActiveHoursRoute.vue?vue&type=style&index=0&id=58243843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58243843",
  null
  
)

export default component.exports